import {Zero, Logger, Components, Utils} from 'Zero';
import Handlebars from 'Vendor/handlebars/dist/handlebars.js'
import SimpleBar from 'Vendor/simplebar'

const Log = new Logger("Zero/StoreLocator/ZResults");

export default class ZResults extends Components {

  get Messages() {
    return {
      "StoreLocator:Init": this.onStoreLocatorInit,
      "StoreLocator:Pin:Clicked": this.onClickedLightPin,
      "StoreLocator:Pin:Unclicked": this.onUnclickedLightPin,
      "StoreLocator:Pin:Hover": this.onHoverLightPin,
      "StoreLocator:Pin:Unhover": this.onUnhoverLightPin,
      "StoreLocator:List:Clicked": this.onClickedLightPin,
      "StoreLocator:List:Unclicked": this.onUnclickedLightPin,
      "StoreLocator:List:Hover": this.onHoverLightPin,
      "StoreLocator:List:Unhover": this.onUnhoverLightPin
    };
  }


  get Selectors() {
    return {
      Template: "#template-store",
      ResultsContainer: "#results-list-container",
      StoreListElement: 'li.js-store-item',
      HighlightedClass: "highlighted",
      SelectedClass: 'selected'
    };
  }

  get react() {
    return {
      onLoadStores: function () {
        const inCart = document.body.classList.contains('t-cart');
        var stores = Zero.$state.StoreLocator.Stores;
        this.ResultsEl[0].innerHTML = ""; // faster than jquery

        let size = 0;
        if (inCart) {
          if (stores && stores.features) {
            var html = [];
            for (var i = 0, store; store = stores.features[i++];) {
              if (store.properties.features.hasOwnProperty('CLICK_AND_COLLECT')) {
                html.push(this.TemplateCompile(store.properties));
                size++;
              }
            }
            this.ResultsEl[0].innerHTML = html.join("");
          }
        } else {
          if (stores && stores.features) {
            var html = [];
            for (var i = 0, store; store = stores.features[i++];) {
              if (!store.properties.storeHidden) {
                html.push(this.TemplateCompile(store.properties));
                size++;
              }
            }
            this.ResultsEl[0].innerHTML = html.join("");
          }
        }

        size > 0 ? this.element.removeClass('is-empty') : this.element.addClass('is-empty');
      }
    }
  }


  get ParsedTemplate() {
    let templateEl = this.element.find( this.Selectors.Template );
    return Handlebars.compile( templateEl[0].innerHTML );
  }


  constructor(element) {
    super(element);

    this.ResultsEl = this.element.find( this.Selectors.ResultsContainer );
    this.ResultPanelTrigger = this.element.find( this.Selectors.ResultPanelTrigger );
    this.TemplateCompile = this.ParsedTemplate;

    this.onLoadStores();
    this.bindEventOnResults();
    this.equalUtil();
    this.ifEquals();
    this.makeCustomScrollbar(element);
  }


  onStoreLocatorInit(msg) {
    this.StoreLocator = msg.StoreLocator;
  }



  bindEventOnResults() {
    this.ResultsEl.off('mouseenter mouseleave').on('mouseenter', this.Selectors.StoreListElement , (e) => {
      if ( this.PinHasBeenClicked ){ return; }
      let data = Utils.JsonDa.data(e.currentTarget, this.Name.toLowerCase() );
      let marker = this.StoreLocator.getMarker( data.store.key );
      if ( marker ){
        this.CAST( "StoreLocator:List:Hover", {marker: marker});
      }
    });

    this.ResultsEl.on('mouseleave', this.Selectors.StoreListElement, (e) => {
      if ( this.PinHasBeenClicked ){ return; }
      let data = Utils.JsonDa.data(e.currentTarget, this.Name.toLowerCase() );
      let marker = this.StoreLocator.getMarker( data.store.key );
      if ( marker ){
        this.CAST( "StoreLocator:List:Unhover", {marker: marker});
      }
    });
  }


  makeCustomScrollbar(element) {
    let isMd = $(window).width() >= 768;
    let isPIS = document.body.classList.contains('t-cart');

    if(isMd && !isPIS) {
      Log.info('custom scrollbar on:', element);
      new SimpleBar(document.getElementById('stores-list-wrapper'));
    }
  }



  onClickedLightPin(msg) {
    let marker = msg.marker;
    let code = marker.getKey();
    let name = this.Name.toLowerCase();
    let storeElement = this.ResultsEl.find( `${this.Selectors.StoreListElement}[data-${name}-store-key='${code}']` );

    storeElement.addClass( this.Selectors.SelectedClass );

    let elContainer = $('.simplebar-content').length ? $('.simplebar-content') : this.element;
    let elContainerOffset = elContainer.offset().top;
    let actScrollTop = elContainer.scrollTop();
    let myElOffset = actScrollTop + storeElement.offset().top - elContainerOffset;

    elContainer.animate({scrollTop: myElOffset}, 400);

    this.PinHasBeenClicked = true;
    this.PrevMarkerCode = code;
  }

  onUnclickedLightPin(msg) {
    let marker = msg.marker;
    let code = marker.getKey();
    let name = this.Name.toLowerCase();
    let storeElement = this.ResultsEl.find( `${this.Selectors.StoreListElement}[data-${name}-store-key='${code}']` );

    storeElement.removeClass(`${this.Selectors.SelectedClass} ${this.Selectors.HighlightedClass}`);
    this.PinHasBeenClicked = false;
    this.PrevMarkerCode = null;
  }

  onHoverLightPin(msg) {
    let marker = msg.marker;
    let code = marker.getKey();
    let name = this.Name.toLowerCase();
    let storeElement = this.ResultsEl.find( `${this.Selectors.StoreListElement}[data-${name}-store-key='${code}']` );

    storeElement.addClass( this.Selectors.HighlightedClass );
  }

  onUnhoverLightPin(msg) {

    let marker = msg.marker;
    let code = marker.getKey();
    let name = this.Name.toLowerCase();
    let storeElement = this.ResultsEl.find( `${this.Selectors.StoreListElement}[data-${name}-store-key='${code}']` );

    storeElement.removeClass( this.Selectors.HighlightedClass );
  }

  equalUtil() {
    Handlebars.registerHelper('equal', function(lvalue, rvalue, options) {
      if (arguments.length < 3)
          throw new Error("Handlebars Helper equal needs 2 parameters");
      if( lvalue!=rvalue ) {
          return options.inverse(this);
      } else {
          return options.fn(this);
      }
    });
  }

  ifEquals() {
    Handlebars.registerHelper('ifEquals', function(a, b, options) {
      if (a === b) {
        return options.fn(this);
      }

      return options.inverse(this);
     });
  }
}

export {
  ZResults
}
